import { notification } from 'antd'

const openedNotifications = new Set()

const betkoBasePopup = (title, content, placement, duration, key) => {
  if (openedNotifications.has(key)) return

  notification.open({
    message: (
      <span style={{ color: '#D6FF00', fontSize: '18px' }}>{title}</span>
    ),
    description: content,
    placement: placement,
    duration: duration,
    key: key,
    style: {
      width: 342,
      background: 'linear-gradient(135deg, #40445E, #111219)',
      border: '1px solid #111219',
      borderRadius: '12px',
      padding: '16px',
    },
    onClose: () => {
      openedNotifications.delete(key)
    },
  })

  openedNotifications.add(key)
}

export const betkoPopup = (
  title,
  descriptionTitle,
  description,
  placement = 'topRight'
) => {
  const uniqueKey = `${title}-${description}-${placement}` // Generate unique key

  const descriptionWithBreaks = description.split('\n').map((line, index) => (
    <div
      key={index}
      style={{
        marginTop: index === 0 ? 0 : '8px',
        fontSize: '16px',
        color: 'white',
        lineHeight: '1.1',
      }}
    >
      {line}
    </div>
  ))

  betkoBasePopup(
    title,
    <div style={{ borderTop: '1px solid #D6FF00', paddingTop: '16px' }}>
      <div style={{ fontWeight: '500', fontSize: '16px', color: 'white' }}>
        {descriptionTitle}
      </div>
      <div style={{ marginTop: '8px', fontSize: '16px', color: 'white' }}>
        {descriptionWithBreaks}
      </div>
    </div>,
    placement,
    10,
    uniqueKey
  )
}

export const betkoSuccessPopup = (description) => {
  betkoPopup('Uspeh', '', description)
}

export const betkoErrorPopup = (description) => {
  betkoPopup('Greška', '', description)
}

export const betkoInfoPopup = (description) => {
  betkoPopup('Obaveštenje', '', description)
}
